import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    Loader,
    Container,
    Content,
    Title,
    MessageCard,
    MarketplaceDashboard,
    MarketplacePurchaseFlow,
    i18n,
    tokens
} from '@simplybenefits/sb-ui-library';
import { downloadPDFToBrowser } from '../../services/helpers';
import { getInvoice } from "../../actions/invoices";
import { getProduct, purchaseProduct, getRate, terminateProduct } from "../../actions/marketplace";

class Marketplace extends PureComponent {
    state = {
        selectedProduct: null
    };

    /**
     * @param productID
     * @returns {Promise<void>}
     * @private
     */
    _selectProduct = async (productID) => {
        const selectedProduct = await this.props.dispatch(getProduct(productID));
        
        this.setState({
            selectedProduct
        });
    };

    render() {
        const { whitelabel, marketplace } = this.props;
        const hasBanking = Number(this.props.meta.paymentsSetup) === 1;

        if (this.props.loading || !marketplace) {
            return <Loader whitelabel={ whitelabel } />;
        }

        return (
            <Container>
                <Content>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center' }}>
                        <Title title={ i18n.t(tokens.titles.marketplace) } customStyle={{ flex: 1 }} />
                    </div>

                    {
                        !hasBanking &&
                            <MessageCard
                                title={ i18n.t(tokens.titles.noBankingData) }
                                subtitle={ i18n.t(tokens.labels.dashboard.youNoPaymentSetup)}
                                btnName={ i18n.t(tokens.buttons["add banking"]) }
                                btn
                                btnOnClick={() => {
                                    this.props.history.push('/my-account');
                                }}
                                small
                            />
                    }

                    <MarketplaceDashboard
                        isMasterSite={ false }
                        whitelabel={ whitelabel }
                        member={ this.props.meta }
                        hasBanking={ hasBanking }
                        purchasedProducts={ this.props.marketplace.purchasedProducts }
                        availableProducts={ this.props.marketplace.availableProducts }
                        refusedProducts={ this.props.marketplace.refusedProducts }
                        invoices={ this.props.invoices || []}
                        selectProduct={ (...params) => this._selectProduct(...params) }
                        getInvoice={ (...params) => this.props.dispatch(getInvoice(...params)) }
                        terminateProduct={ (...params) => this.props.dispatch(terminateProduct(...params)) }
                        downloadPDFToBrowser={ (...params) => downloadPDFToBrowser(...params) }
                        dispatch={ this.props.dispatch }
                    />

                    {
                        this.state.selectedProduct &&
                            <MarketplacePurchaseFlow
                                loading={ this.props.loading }
                                whitelabel={ whitelabel }
                                member={ this.props.meta }
                                selectedProduct={ this.state.selectedProduct }
                                purchaseProduct={ (...params) => this.props.dispatch(purchaseProduct(...params)) }
                                getRate={ (...params) => getRate(...params)}
                                onClose={ () => {
                                    this.setState({
                                        selectedProduct: null
                                    });
                                }}
                            />
                    }
                </Content>
            </Container>
        );
    }
}

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta,
    loading: state.marketplace.loading,
    whitelabel: state.whitelabel,
    invoices: state.invoices.items,
    marketplace: state.marketplace
});

export default connect(mapStateToProps)(Marketplace);